import request from "@/utils/request";

export function getfewProcessApi(params) {
  return request({
    url: "?c=pp&a=process&do=getfew",
    method: "get",
    params
  });
}

export function getProcessListApi(params) {
  return request({
    url: "?c=pp&a=process&do=list",
    method: "get",
    params
  });
}

export function postProcessApi(data) {
  return request({
    url: "?c=pp&a=process&do=post",
    method: "post",
    data
  });
}

export function getProcessApi(params) {
  return request({
    url: "?c=pp&a=process&do=get",
    method: "get",
    params
  });
}

export function processDelApi(data) {
  return request({
    url: "?c=pp&a=process&do=del",
    method: "post",
    data
  });
}

export function importProcessApi(data) {
  return request({
    url: "?c=pp&a=process&do=import",
    method: "post",
    data
  });
}

export function exportProcessApi(params) {
  return request({
    url: "?c=pp&a=process&do=export",
    method: "get",
    params
  });
}

export function precreateNoApi(data) {
  return request({
    url: "?c=pp&a=process&do=precreate",
    method: "post",
    data
  })
}

